module.exports = __webpack_public_path__ + "img/bv.f726a07d.svg";